var stripeScript
export default {
  data() {
    return {
      creditPayCard: null,
      public_key: ''
    }
  },
  methods: {
    loadStripeScript(publicKey, success = () => { }) {
      this.public_key = publicKey
      if (!stripeScript) {
        stripeScript = window.document.createElement('script')
        stripeScript.src = 'https://js.stripe.com/v3/'
        stripeScript.onload = () => {
          console.log('loadStripeScript成功===========')
          window.stripe = Stripe(publicKey)
          window.stripeElements = window.stripe.elements()
          success && success()
        }
        var head = window.document.head || window.document.getElementsByTagName('head')[0] || window.document.documentElement
        head.insertBefore(stripeScript, head.firstChild)
      } else {
        console.log('Stripe已加载')
        if (this.public_key !== publicKey) {
          window.stripe = Stripe(publicKey)
          window.stripeElements = window.stripe.elements()
        }
        success && success()
      }
    },
    // 创建 Stripe 节点
    creditStripeElement(data, dom, success) {
      if (window.stripe) {
        const layout = { layout: "tabs" }
        const options = {
          clientSecret: data.clientSecret,
          appearance: { theme: "stripe" }
        }
        this.creditPayCard = window.stripe.elements(options)
        const paymentElement = this.creditPayCard.create("payment", layout)
        paymentElement.mount(dom)
        success && success()
      } else {
        console.log("stripe:", window.stripe)
        this.$toast("loading...")
      }
    },
  }
}
